import * as React from "react";
import { Box } from "@mui/material";

import { ResizeHandle } from "./resize-handle";
import { useResize, type UseResizeProps } from "./use-resize";

export const ResizeBox = (props) => {
  const {
    handlePosition,
    onResize,
    defaultWidth,
    isResizable = true,
    children,
    ...rest
  } = props;

  const { getContainerProps, getHandleProps } = useResize({
    handlePosition,
    onResize,
    defaultWidth,
    isResizable,
  });

  return (
    <Box
      {...rest}
      {...getContainerProps(rest)}
      __css={{ position: "relative" }}
    >
      {children}

      {isResizable && <ResizeHandle {...getHandleProps()} />}
    </Box>
  );
};

ResizeBox.displayName = "ResizeBox";
